var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.74563 47.6067L30.804 10.7136C31.5873 9.46025 33.4127 9.46026 34.196 10.7136L57.254 47.6067C58.0865 48.9388 57.1288 50.6667 55.558 50.6667L9.44162 50.6667C7.87075 50.6667 6.91306 48.9387 7.74563 47.6067Z",
    fill: "#272937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.5 34L32.5 24",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.5 41C30.5 39.8954 31.3954 39 32.5 39C33.6046 39 34.5 39.8954 34.5 41C34.5 42.1046 33.6046 43 32.5 43C31.3954 43 30.5 42.1046 30.5 41Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.83c1aafe81e62b75389964ed462c7e2d.svg";
export { ForwardRef as ReactComponent };